export const service_id = "service_2oboxm1"
export const templete_id = "template_z1cgf4i"
export const p_key = "4B-sqmqWRZ_AVEr4j"

//벌레제보 email 서비스용
